import { render } from "./Asiento.vue?vue&type=template&id=4afde5be&scoped=true"
import script from "./Asiento.vue?vue&type=script&lang=js"
export * from "./Asiento.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=4afde5be&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afde5be"]])

export default __exports__